// extracted by mini-css-extract-plugin
export default {"callbackRedirect":"App_callbackRedirect__a7LdI","appLoader":"App_appLoader__1lpmx"};